import { MvnMessage } from "@newLibs/utils";
import { DOCS_DOCUMENT_LANG } from "@maven-msg/lang/docs/document";

export function formatSignerNameWithIndex(req: { name?: string; signerIndex: number }): string {
  const { name, signerIndex } = req;

  return name ? `${signerIndex} - ${name}` : MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_NTH_SIGNER_LABEL, { signerIndex });
}
